import { Checkbox, Space, Select } from "antd"
import { InfoCard } from "../common/InfoCard"
import { LabelRow } from "../common/LabelRow"
import { ManualInputRow } from "../common/ManualInputRow"
import { PropertySetSelect } from "../common/PropertySetSelect"
import { UnitProps } from "../unitTypes"
import { useState } from "react"
import { useUpdateEffect } from "ahooks"

interface ExchangerOtherTabProps extends UnitProps {
  onChange: (changes) => void
}

export function ExchangerOtherTab(props: ExchangerOtherTabProps) {
  const {unit, data, onChange} = props
  const tempOptions = unit?.simArgs?.TEMPERATURE_APPROACH || {}
  const energyArg = unit?.simArgs?.ENERGY_BALANCE
  const unitData = data?.vars?.UNIT
  const [tempApproach, setTempApproach] = useState(tempOptions)
  const [enableEnergy, setEnableEnergy] = useState(!!energyArg)

  useUpdateEffect(() => {
    setTempApproach(tempOptions)
  }, [tempOptions])

  useUpdateEffect(() => {
    setEnableEnergy(!!energyArg)
  }, [energyArg])

  const changeSimArgs = (changes) => {
    const simArgs = {...(unit.simArgs || {}), ...changes}
    onChange(simArgs)
  }

  const onEnergyChange = (e) => {
    const isChecked = e.target.checked
    setEnableEnergy(isChecked)
    changeSimArgs({ENERGY_BALANCE: isChecked})
  }

  const onTempApproachChange = (e) => {
    const isChecked = e.target.checked
    const newTemp = {...tempApproach, ACTIVE: isChecked}
    setTempApproach(newTemp)
    const changes: any = {TEMPERATURE_APPROACH: newTemp}
    changeSimArgs(changes)
  }

  const splitValue = (val: string) => {
    const values = val.split(':')
    return {STREAM: Number(values[0]), POINT: values[1]}
  }

  const onTemp1Change = (val) => {
    const changes = splitValue(val)
    const newApproach = {
      ...tempApproach,
      POINT1: changes
    }
    const temp1Changes = {
      TEMPERATURE_APPROACH: newApproach
    }
    setTempApproach(newApproach)
    changeSimArgs(temp1Changes)
  }

  const onTemp2Change = (val) => {
    const changes = splitValue(val)
    const newApproach = {
      ...tempApproach,
      POINT2: changes
    }
    const temp2Changes = {
      TEMPERATURE_APPROACH: newApproach
    }
    setTempApproach(newApproach)
    changeSimArgs(temp2Changes)
  }

  const enableTemp = !!tempApproach.ACTIVE

  const approachContent = () => {
    if (!enableTemp) return null;
    const {POINT1, POINT2} = tempApproach;
    const point1Val = POINT1 ? `${POINT1.STREAM}:${POINT1.POINT}` : undefined
    const point2Val = POINT2 ? `${POINT2.STREAM}:${POINT2.POINT}` : undefined
    return <>
      <LabelRow label="Temperature 1" value={<Select
        value={point1Val}
        onChange={onTemp1Change} style={{minWidth: 160, maxWidth: 240}}>
        <Select.Option value="1:IN">Stream1 Inlet</Select.Option>
        <Select.Option value="1:OUT">Stream1 Outlet</Select.Option>
        <Select.Option value="2:IN">Stream2 Inlet</Select.Option>
        <Select.Option value="2:OUT">Stream2 Outlet</Select.Option>
        <Select.Option value="1:BP">Stream1 Balance Point</Select.Option>
        <Select.Option value="2:BP">Stream2 Balance Point</Select.Option>
      </Select>}/>
      <LabelRow label="Temperature 2" value={<Select value={point2Val} onChange={onTemp2Change} style={{minWidth: 160, maxWidth: 240}}>
        <Select.Option value="1:IN">Stream1 Inlet</Select.Option>
        <Select.Option value="1:OUT">Stream1 Outlet</Select.Option>
        <Select.Option value="2:IN">Stream2 Inlet</Select.Option>
        <Select.Option value="2:OUT">Stream2 Outlet</Select.Option>
        <Select.Option value="1:BP">Stream1 Balance Point</Select.Option>
        <Select.Option value="2:BP">Stream2 Balance Point</Select.Option>
      </Select>}/>
      <ManualInputRow label="Temperature Delta" dimCode='DTEMP' data={unitData?.T_APP} attrKey=":UNIT:T_APP" unitId={unit.id}/>
    </>
  }
  
  return <div className="mt-1">
    <InfoCard title={<Checkbox onChange={onEnergyChange} checked={enableEnergy}>Energy Balance</Checkbox>} children={null}/>
    <InfoCard title={
      <Space>
        <Checkbox checked={enableTemp} onChange={onTempApproachChange} />
        <span>Temperature Approach</span>
      </Space>
    } className="mt-1" children={approachContent()} />
    <PropertySetSelect disabled title="Property Set Stream1" unitId={unit.id} value={data?.args?.tpps1} />
    <PropertySetSelect disabled title="Property Set Stream2" unitId={unit.id} value={data?.args?.tpps2} />
  </div>
}